const formatCode = code => {
  const codeLength = String(code).length;
  switch (codeLength) {
    case 1:
      return `000${code}`;
    case 2:
      return `00${code}`;
    case 3:
      return `00${code}`;
    default:
      return `${code}`;
  }
};

export default formatCode;
